import styled from 'styled-components'

import { colors } from '../../../module/colors'
import {
  size_2,
  size_4,
  text_lg,
  text_sm,
  text_xs,
  text_thin,
  backgroundCoverImg,
} from '../../../module/style-variables'

const cardHeight = '160px'
const detailZindex = '2'
const detailBackgroundZindex = '1'

export const QuestionBankCard = styled.div`
  position: relative;
  margin: ${size_4} ${size_4} 0 ${size_4};
  ${backgroundCoverImg};
`

export const QuestionBankCardInner = styled.div`
  overflow: hidden;
  height: ${cardHeight};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: 'rgba(2, 2, 2, 0.23)';
`

export const QuestionBankCardDetails = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`

export const QuestionBankCardDetailsLeft = styled.div`
  padding: ${size_4};
  width: 50%;
  z-index: ${detailZindex};
`

export const QuestionBankCardDetailsLeftBackground = styled.div`
  height: ${cardHeight};
  width: 50%;
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${detailBackgroundZindex};
  @supports (transform: skew(-50deg)) {
    transform: skew(-50deg);
    width: calc(50% + 100px);
    left: -100px;
  }
`

export const QuestionBankCardDetailsRight = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const QuestionBankTitle = styled.h2`
  color: ${colors.copy};
  padding-bottom: ${size_2};
  ${text_lg};
  ${text_thin};
`

export const QuestionBankSubTitle = styled.h3`
  color: ${colors.copyLight};
  text-transform: uppercase;
  ${text_sm};
`

export const StartQuestionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${size_2};
`

const counterSize = '28px'

export const QuestionBankCounterContainer = styled.div`
  width: 63px;
  display: flex;
  flex-direction: column;
  margin-top: ${size_4};
  justify-content: center;
  align-items: center;
`

export const QuestionBankCounter = styled.div`
  background-color: ${colors.secondary};
  color: ${colors.textOnSecondary};
  height: ${counterSize};
  width: ${counterSize};
  border-radius: ${counterSize};
  display: flex;
  justify-content: center;
  align-items: center;
  ${text_sm};
  ${text_thin};
`
export const QuestionBankCounterTitle = styled.h4`
  text-align: center;
  padding-top: ${size_2};
  color: ${colors.copy};
  ${text_xs};
  ${text_thin};
`
export const QuestionBankProgressContainer = styled.div`
  z-index: ${detailZindex};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/QuestionBankCard/QuestionBankCard-styled.js